
export const installerUserPermissions = [
    {
        name: "Monitoring",
        route: "monitoring",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transactions",
        route: "transactions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reader preset",
        route: "reader-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "controller preset",
        route: "controller-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "biometric preset",
        route: "biometric-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "device preset",
        route: "device-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "lock preset",
        route: "lock-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    // {
    //     name: "locker preset",
    //     route: "locker-preset",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    {
        name: "Alarm Viewer",
        route: "alarms",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Dashboard",
        route: "dashboard",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transaction",
        route: "transaction-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "transaction-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "time-attendance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time & Attendance",
        route: "time-attendance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Hardware",
        route: "hardware",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Buildings",
        route: "buildings",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Floors",
        route: "floors",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Lifts",
        route: "lifts",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Presets",
        route: "presets",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Engine",
        route: "engine",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Doors",
        route: "doors",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Zones",
        route: "zones",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Common Zones",
        route: "common-zones",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Device Time Patterns",
        route: "device-time-patterns",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time Triggered Actions",
        route: "time-triggered-actions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Master Controller",
        route: "master-controller",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "I/O & Modules",
        route: "io-module",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "lock",
        route: "lock",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "locker",
        route: "locker",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    }
    // {
    //     name: "Truncation",
    //     route: "truncation",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },

]
